export default "__VITE_ASSET__949271f7__"